module.exports = __webpack_public_path__ + "img/CHEVROLET.28181f7.jpg";